import src from "IMAGE";
export default { src, width: 136, height: 136, blurWidth: 0, blurHeight: 0};
